import { backgroundColorContainerSx, mainDivSx } from 'components/styles/container';
import { Box } from 'components/ui';
import { MenuProvider, useMenu } from 'contexts/menu';
import { useSpace } from 'contexts/space';
import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthenticated } from 'utils/authentication';
import { ProfileLink, SpacesLink } from 'utils/link';
import Loader from 'components/layout/loader';
import MainContainer from 'components/layout/main_container';
import SideMenu from 'components/layout/side_menu';
import useMobile from 'hooks/use_mobile';
import theme from 'theme';

const PrivateLayout = () => {
  const isMobile = useMobile();
  const { sidebarVisible } = useMenu();
  const style = sidebarVisible && !isMobile ? { marginLeft: theme.width.sideMenu } : {};

  return (
    <Box sx={backgroundColorContainerSx}>
      <Box sx={mainDivSx} style={style}>
        <SideMenu />
        <MainContainer>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </MainContainer>
      </Box>
    </Box>
  );
};

const PrivateRoute = () => {
  const { currentSpaceId } = useSpace();
  const { pathname } = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/users/login" />;
  }

  const allowedWithoutSpace = [ProfileLink(), SpacesLink()];
  if (!currentSpaceId && !allowedWithoutSpace.includes(pathname)) {
    return <Navigate to={SpacesLink()} />;
  }

  return (
    <MenuProvider>
      <PrivateLayout />
    </MenuProvider>
  );
};

export default PrivateRoute;
